
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'Popup',
})
export default class Popup extends Vue {
  @Prop(Boolean) value: boolean;
  @Prop([String, Number]) height: string | number;
  @Prop({ type: String, default: '' }) clazz: string;
  @Prop({ type: String, default: '' }) title: string;
  @Prop({ type: String, default: '' }) cancelText!: string;
  @Prop({ type: String, default: '' }) confirmText!: string;
  @Prop({ type: Boolean, default: false }) closeOnClickOverlay!: boolean;
  @Prop({ type: Boolean, default: false }) headerCss: false;
  @Prop({ type: Boolean, default: false }) appendToBody;
  @Prop({ type: Object, default: () => ({}) }) customStyle;
  @Prop({ type: Boolean, default: true }) hasConfirm!: boolean;
  @Prop({ type: Boolean, default: false }) disableCancel: boolean;

  get styleObj(): any {
    const { height } = this;

    const heightStr = '300px';
    return Object.keys(this.customStyle).length > 0 ? this.customStyle : { height: height || heightStr };
  }

  get hasHeader(): boolean {
    const { cancelText, confirmText, title } = this;
    return cancelText.length > 0 || confirmText.length > 0 || title.length > 0;
  }

  get leftBtnText() {
    return this.cancelText || this.$t('common_cancel');
  }

  get rightBtnText() {
    return this.confirmText || this.$t('common_confirm');
  }

  handleSubmit(): void {
    this.$emit('confirm');
  }

  closePopup(): void {
    if (this.hasHeader) {
      this.$emit('cancel');
    } else {
      this.$emit('confirm');
      this.$emit('input', false);
    }
  }
}
